
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalPluggedNoChargeLow as ObiBatteryHorizontalPluggedNoChargeLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-plugged-no-charge-low.js';
 
 
 

 
 export const ObiBatteryHorizontalPluggedNoChargeLow = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-plugged-no-charge-low',
   elementClass: ObiBatteryHorizontalPluggedNoChargeLowElement,
   events: {
     
   }
  });
 
 